/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiestitle1Inputs */

const en_opportunitiestitle1 = /** @type {(inputs: Opportunitiestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunity board`)
};

const de_opportunitiestitle1 = /** @type {(inputs: Opportunitiestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chancen-Board`)
};

/**
* | output |
* | --- |
* | "Opportunity board" |
*
* @param {Opportunitiestitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiestitle1 = /** @type {((inputs?: Opportunitiestitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiestitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiestitle1(inputs)
	return de_opportunitiestitle1(inputs)
});
export { opportunitiestitle1 as "opportunitiesTitle" }